// Global Styles - Now using CSS instead of styled-components
import './GlobalStyle.css';

const GlobalStyle = () => {
  return null; // This component now just imports the CSS
};

export default GlobalStyle;
